<template>
  <div>
    <List @toDetail="GoDetails" :dataList="dataList" :activeNum="activeNum" :dishTypeOpts="dishTypeOpts" />
    <template v-if="false">
      <ul class="ul" v-for="v in DataList" :key="v.id" @click="GoDetails(v.id, v)">
        <li class="firstname" :style="{ 'background-color': color16() }" v-if="v.lesseeName">
          {{ v.lesseeName.charAt(0) }}
        </li>
        <li class="content-li">
          <div class="name li-item 33">
            <div class="name-top">
              <p class="black">{{ v.lesseeName }}</p>
              <a-tag class="label" color="blue" v-if="v.takeLookCount && v.takeLookCount > 2"> 多次带看 </a-tag>
              <a-tag class="label" color="blue" v-if="v.takeLookCount && v.takeLookCount === 2"> 2次带看 </a-tag>
              <a-tag class="label" color="pink" v-if="v.identityFive === 'Y'"> 五 </a-tag>
              <a-tag class="label" color="green" v-if="v.identityExcellent === 'Y'"> 优 </a-tag>
              <a-tag class="label" color="orange" v-if="v.identityWill === 'Y'"> 意向 </a-tag>
            </div>
            <p class="words" v-if="v.customerType">
              {{ v.customerType | filterDict(customer_type_list) }}
            </p>
            <p class="words" v-else>暂无类型数据</p>
          </div>
          <div class="address li-item">
            <p class="black" v-if="v.shopNatureId">{{ v.shopNatureId | filterDict(shop_nature) }}</p>
            <p class="black" v-else>暂无类型数据</p>
            <p
              class="con-overflow"
              :title="v.businessDistrictName ? v.businessDistrictName + v.streetName : '暂无地址信息'"
            >
              {{ v.businessDistrictName ? v.businessDistrictName + v.streetName : '暂无地址信息' }}
            </p>
          </div>

          <div class="price li-item">
            <div class="red">
              <p
                class="con-overflow"
                :title="(v.requirementAreaStart || 0) + '-' + (v.requirementAreaEnd || 0) + 'm²'"
                v-if="v.requirementPriceStart"
              >
                <!-- {{ v.requirementPriceStart | keepTwo_wan }}-{{ v.requirementPriceEnd | keepTwo_wan }} -->
                {{ v.requirementPriceStart ? v.requirementPriceStart : '-' }}万 ~
                {{ v.requirementPriceEnd ? v.requirementPriceEnd : '-' }}万元
              </p>
              <p v-else>暂无售价数据</p>
            </div>
            <p>
              {{ v.investmentType | filterDict(investment_type_list) }}
              <span v-if="v.investmentType && v.paymentType">/</span>
              {{ v.paymentType | filterDict(payment_method_list) }}
            </p>
          </div>
          <div class="desc li-item">
            <p
              class="black con-overflow"
              v-if="v.followUpCreateTime"
              :title="$moment(v.followUpCreateTime).format('YY-MM-DD HH:mm') + ' 跟进'"
            >
              {{ v.followUpCreateTime.substr(0, 10) + ' 跟进' }}
            </p>
            <p class="black" v-else>暂无跟进</p>
            <p class="con-overflow" :title="v.takeLookCount + '次带看，' + v.inMoreCount + '次一带多看'">
              {{ v.takeLookCount }} 次带看，{{ v.inMoreCount }} 次一带多看
            </p>
          </div>
          <div class="agent li-item">
            <p class="black con-overflow" :title="((v && v.teamName) || '*') + '-' + v.relatedPersonnelName">
              {{ v.teamName || '*' }}-{{ v.relatedPersonnelName }}
              <!--{{
              v.relatedPersonnelName && v.relatedPersonnelName.length > 7
                ? v.relatedPersonnelName.substr(0, 7) + '...'
                : v.relatedPersonnelName
            }}-->
            </p>
            <p class="con-overflow" :title="v.relatedPersonnelCreateTime + '录入'">
              {{ v.relatedPersonnelCreateTime + '录入' }}
            </p>
          </div>
          <div v-for="d in dishTypeOpts" :key="d.dictValue">
            <div
              class="type li-item"
              :class="{
                type1: d.dictLabel == '私盘',
                type2: d.dictLabel == '单店',
                type3: d.dictLabel == '公司',
              }"
              v-if="d.dictValue == v.dishType"
            >
              {{ d.dictLabel }}
            </div>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import List from '../../list/modules/list.vue'

export default {
  components: {
    List
  },
  props: {
    dataList: {
      type: Array,
      default: () => [],
      require: true
    },
    dishTypeOpts: {
      type: Array,
      default: () => [],
      require: true
    },
    activeNum: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      DataList: [],
      payment_method_list: [],
      customer_type_list: [],
      investment_type_list: [],
      shop_nature: []
    }
  },
  watch: {
    dataList (val) {
      this.DataList = val
    },
    // 监听
    activeNum: {
      handler (val) {},
      immediate: true
    }
  },
  methods: {
    // 点击跳转客源列表详情页
    GoDetails (id, item) {
      sessionStorage.setItem('toDetail', JSON.stringify({ fromPage: 'toDetails' }))
      this.$router.push({
        path: '/tourist/sellDetails',
        query: {
          id: id,
          activeNum: this.activeNum,
          storeId: item.storeId,
          teamId: item.teamId,
          userStatus: item.userStatus,
          canTabs: true
          // fromPage:'list'
        }
      })
    },
    // 十六进制颜色随机
    color16 () {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      return color
    },
    DICT () {
      this.getDicts('payment_type2').then((response) => {
        this.payment_method_list = response.data
        // console.log('付款方式', this.payment_method_list)
      })
      this.getDicts('customer_type').then((response) => {
        this.customer_type_list = response.data
        // console.log('客户类型', this.customer_type_list)
      })
      this.getDicts('investment_type').then((response) => {
        this.investment_type_list = response.data
        // console.log('投资类型', this.investment_type_list)
      })
      this.getDicts('shop_nature').then((response) => {
        this.shop_nature = response.data
        // console.log('商铺性质', this.typeOptions)
      })
    }
  },
  created () {
    this.DICT()
  }
}
</script>

<style lang="less" scoped>
.con-overflow {
  width: 98%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ul {
  &:hover {
    background: #f0f5ff;
  }
  cursor: pointer;
  display: flex;
  height: 120px;
  align-items: center;
  list-style: none;
  padding-left: 0;
  margin-left: 10px;
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
  .black {
    color: #000;
    font-weight: 700;
    margin-right: 6px;
  }
  .firstname {
    font-size: 30px;
    width: 70px;
    height: 70px;
    background-color: var(--ThemeColor);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    margin-right: 30px;
  }

  .content-li {
    flex: 1;
    display: flex;
    height: 120px;
    border-bottom: 1px solid #ccc;
    width: calc(100% - 100px);
    .li-item {
      width: 17%;
    }
    .name {
      display: flex;
      flex-direction: column;
      padding: 26px 0;
      justify-content: space-between;
      margin-right: 25px;
      .name-top {
        display: flex;
        .label {
          height: 20px;
        }
      }
      .words {
        width: 300px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .address {
      padding: 30px 0;
    }
    .price {
      padding: 30px 0;
      .red {
        color: red;
        font-weight: 700;
      }
    }
    .desc {
      padding: 30px 0;
    }
    .agent {
      padding: 30px 0;
    }
    .type {
      margin-top: 40px;
      color: white;
      width: 50px;
      height: 30px;
      line-height: 30px;
      border-radius: 16px;
      text-align: center;
    }
    .type1 {
      background-color: #389e0d;
    }
    .type2 {
      background-color: #d48806;
    }
    .type3 {
      background-color: #cf1322;
    }
  }
}
</style>
